import ActividadesRepository from "@/services/ActividadesRepository"
import MovimientoAnimalRepository from "@/services/MovimientoAnimalRepository"
import ReproduccionRepository from "@/services/ReproduccionRepository"
import Vue from 'vue'

export default{
  namespaced: true,
  state:{
    listaMovimientos: [],
    listaMovimientosOrdenados: [],
    lastIdSubconcepto: 0,
    listaMovimientosAnimal: [],
    listaReproducciones: []
  },
  getters:{
    getMovimiento: (state) => (idMovimiento) => {
      return state.listaMovimientos.find(movimiento => movimiento.idMovimientoFinanciero === idMovimiento)
    }
  },
  mutations:{
    setMovimientos(state, payload){
      state.listaMovimientosOrdenados = payload.conceptos.map(con =>{
        let movs = payload.resp.filter(movimiento => movimiento.subconcepto.idConcepto === con.idConcepto)
        movs.map(movimiento => {
          movimiento.fechaFormated = Vue.filter('fhDate')(movimiento.fecha)
        })
        return{
          concepto: con,
          movimientos: movs
        }
      })

      state.listaMovimientos = payload.resp.map(mov => {
        mov.fechaFormated = Vue.filter('fhDate')(mov.fecha)
        return mov
      })
    },
    
    setLastIdSubconcepto(state,idSubconcepto){
      state.lastIdSubconcepto = idSubconcepto
    },

    clearMovimientos(state){
      state.listaMovimientosOrdenados = []
      state.listaMovimientos = []
      state.lastIdSubconcepto = 0
    },

    clearLastSubconcepto(state){
      state.lastIdSubconcepto = 0
    },

    setMovimientosAnimal(state, listaMovimientos){
      listaMovimientos.map(mov=>{
        mov.fechaFormated = Vue.filter('fhDate')(mov.fecha),
        mov.categoriaAnimal = `${mov.detalleMovimiento[0].detalleCategoria[0].subcategoriaAnimal.categoriaAnimal.nombre} / ${mov.detalleMovimiento[0].detalleCategoria[0].subcategoriaAnimal.nombre}`
      })
      state.listaMovimientosAnimal = listaMovimientos
    },

    clearListaMovimientoAnimal(state){
      state.listaMovimientosAnimal = []
    },

    setListaReproducciones(state, lista){
      state.listaReproducciones = lista
    },

    clearListaReproducciones(state){
      state.listaReproducciones = []
    },
  },
  actions:{
    async fetchListaMovimientos({state, commit, rootState}, requestInfo ){
      if(state.listaMovimientosOrdenados && state.listaMovimientosOrdenados.length !== 0 && requestInfo===undefined && state.lastIdSubconcepto===0){
        return
      }
      let idFichaGanadera = rootState.fichas.fichaGanadera.idFichaGanadera
      let conceptos = rootState.conceptos.conceptos
      if(idFichaGanadera && idFichaGanadera !== 0){
        let resp = await ActividadesRepository.listaMovimientosFinancieros(idFichaGanadera, requestInfo?.idSubconcepto, requestInfo?.fechaInicio, requestInfo?.fechaFin)
        commit('setMovimientos',{resp:resp, conceptos:conceptos})
        if(requestInfo!==undefined && requestInfo.idSubconcepto!==0){
          commit('setLastIdSubconcepto',requestInfo.idSubconcepto)
        }else{
          commit('clearLastSubconcepto')
        }
      }
    },

    clearMovimientosList({commit}){
      commit('clearMovimientos')
    },

    async fetchListaMovimientosAnimal({state, commit, rootState}, requestInfo){
      if(state.listaMovimientosAnimal && state.listaMovimientosAnimal.length !== 0){
        return
      }
      let idFichaGanadera = rootState.fichas.fichaGanadera.idFichaGanadera
      let resp = await MovimientoAnimalRepository.listaMovimientosAnimal(idFichaGanadera,requestInfo?.idTipoMovimientoAnimal, requestInfo?.fechaDesde, requestInfo?.fechaHasta)
      commit('setMovimientosAnimal',resp)
    },

    clearListaMovimientoAnimal({commit}){
      commit('clearListaMovimientoAnimal')
    },

    async fetchListaReproducciones({state, commit, rootState}){
      if(state.listaReproducciones && state.listaReproducciones.length !== 0){
        return
      }
      let idFichaGanadera = rootState.fichas.fichaGanadera.idFichaGanadera
      let resp = await ReproduccionRepository.listaReproduccion(idFichaGanadera)
      commit('setListaReproducciones',resp)
    },

    clearListaReproducciones({commit}){
      commit('clearListaReproducciones')
    }
  }
}